<template>
	<div class="container">
		<div class="row d-flex justify-content-center mt-10 mb-10">
			<div class="col-lg-9">
				<card-component
					title="Política de Privacidade"
					backRoute="/access"
					:back="true"
					:footer-background="confirmCheckbox"
				>
					<b-card-text>
						<h1>Política de Privacidade<span> da PagBrasil</span></h1>
						<p>
							<ol>
								<li v-for="(term, index) in useTerms" :key="index">
									{{ term.text }}
									<ol v-if="term.subTerms !== 'undefined'">
										<li v-for="(subTerm, subIndex) in term.subTerms" :key="subIndex">{{ subTerm.text }}</li>
									</ol>
								</li>
							</ol>
						</p>
						<div class="footer row">
							<div class="col-lg-6 d-flex align-items-center p-0">
								<b-form-checkbox
									id="checkbox-confirm"
									v-model="confirmCheckbox"
									name="checkbox-confirm"
									:unchecked-value="false"
								>
									Concordo com a
									<router-link to="/policy">Política de Privacidade</router-link>.
								</b-form-checkbox>
							</div>
							<div class="col-lg-6">
								<b-button
									@click="pushAccepted"
									size="lg"
									:class="confirmCheckbox ? 'bg-primary text-white' : ''"
									class="float-right"
									:disabled="!confirmCheckbox"
									style="padding: 15px 50px;"
									>Concordo com os termos</b-button
								>
							</div>
						</div>
					</b-card-text>
				</card-component>
			</div>
		</div>
	</div>
</template>
<script>
import CardComponent from "@/components/Form/CardComponent";

export default {
	name: "PolicyPage",
	components: {
		CardComponent,
	},
	data() {
		return {
			confirmCheckbox: false,
			useTerms: this.$t('useTerms')
		};
	},
	methods: {
		pushAccepted: function() {
			this.$store.state.form.acceptedPolicy = true;
			this.$router.push('access');
		}
	}
};
</script>
<style lang="scss" scoped>
ol {
	padding-left: 15px;
	counter-reset: main;
}

li {
	padding-left: 20px;
	font-family: "Nunito Sans", sans-serif;
	margin-bottom: 30px;
	color: #686361;
	counter-reset: item;
	counter-increment: main;
}

li ol {
	margin-top: 20px;
}

ol li::marker {
	font-weight: Bold;
	font-family: "Montserrat", sans-serif;
	color: #32302F;
	font-size: 16px;
}

li ol {
	list-style-type: none;
}

li ol li {
	counter-increment: item;
	counter-increment: main;
	margin-bottom: 15px;
}

li ol li::marker {
	font-weight: Bold;
	font-family: "Nunito Sans", sans-serif;
	color: #686361;
	font-size: 16px;
	content: counters(main, ".");
}
</style>
